import { render, staticRenderFns } from "./officers.vue?vue&type=template&id=05a54950"
import script from "./officers.vue?vue&type=script&lang=js"
export * from "./officers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports